export enum BillingMethod {
  CARD = 'CARD',
  SEPA_DEBIT = 'SEPA_DEBIT',
  INVOICE = 'INVOICE',
}
